import { Patient } from "@/api/dtos";
import { Box, styled } from "@mui/material";
import { IPatientInformationProps, PatientContext, PatientInformation, PatientStateContext } from "@ngt/opms";
import { DateTime } from "luxon";
import { FC, useContext, useMemo } from "react";

const StyledBox = styled(Box) (({theme}) => ({
    padding: theme.spacing(3),
    marginBottom: theme.spacing(2)
}));

interface IPatientDetailsProps extends Omit<IPatientInformationProps, 'patient' | 'patientState' | 'institution'> {

}

const PatientDetails: FC<IPatientDetailsProps> = ({
    patientCaption,
    patientStateCaption,
    patientStateText
}) => {
    const { data: untypedPatient } = useContext(PatientContext);
    const { data: patientState } = useContext(PatientStateContext);
    const patient = untypedPatient as Patient;
    
    const defaultPatientCaption = useMemo(() => patient?.initials, [patient]);
    const defaultPatientStateCaption = useMemo(() => DateTime.fromISO((patient as Patient)?.patientStateChangeDate ?? DateTime.local().toISO({ includeOffset: false })).toFormat('dd-MMM-yyyy'), [patient]);
    const defaultPatientStateText = useMemo(() => {
        return patientState?.name;
    }, [patient?.patientStateId, patientState])

    return (
        <PatientInformation
            patientCaption={patientCaption ?? defaultPatientCaption}
            patientStateText={patientStateText ?? defaultPatientStateText}
            patientStateCaption={patientStateCaption ?? defaultPatientStateCaption}
        />
    )
}

export const FormPatientDetails: FC<IPatientDetailsProps> = (props) => {
    return (
        <StyledBox>
            <PatientDetails
                {...props} 
            />
        </StyledBox>
    )
}

export default PatientDetails;